
import respUtility from '~/mixins/respUtility';

export default {
  name: 'ListingProductsListItemWishlistBtn',
  mixins: [respUtility],
  props: {
    productId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    getWishList() {
      return this.$store.state.listing.wishList;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    colorIcon() {
      return this.isBoutiquePage ? this.$cp.black : this.$cp.black;
    },
  },
};
